var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("数据查询")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("产品数据")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "query" },
      [
        _c("div", { staticClass: "title" }, [
          _c(
            "span",
            {
              style: { color: _vm.active === 1 ? "" : "#000" },
              on: {
                click: function ($event) {
                  return _vm.selectQuery(1)
                },
              },
            },
            [_vm._v("查询商品")]
          ),
          _c(
            "span",
            {
              style: { color: _vm.active === 2 ? "" : "#000" },
              on: {
                click: function ($event) {
                  return _vm.selectQuery(2)
                },
              },
            },
            [_vm._v("查询赠品")]
          ),
        ]),
        _c(
          "el-form",
          {
            ref: "form",
            attrs: { model: _vm.queryForm, "label-width": "80px" },
          },
          [
            _c(
              "el-form-item",
              { staticClass: "formItem", attrs: { label: "产品名称" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入产品名称" },
                  model: {
                    value: _vm.queryForm.info,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryForm, "info", $$v)
                    },
                    expression: "queryForm.info",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { staticClass: "formItem", attrs: { label: "选择品牌" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      clearable: "",
                      placeholder: "请选择品牌",
                      filterable: "",
                      "default-first-option": "",
                    },
                    model: {
                      value: _vm.queryForm.service,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryForm, "service", $$v)
                      },
                      expression: "queryForm.service",
                    },
                  },
                  _vm._l(_vm.brand, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { staticClass: "formItem", attrs: { label: "商品厂家" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入商品厂家" },
                  model: {
                    value: _vm.queryForm.orderId,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryForm, "orderId", $$v)
                    },
                    expression: "queryForm.orderId",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { staticClass: "formItem", attrs: { label: "商品仓库" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      clearable: "",
                      placeholder: "请选择商品仓库",
                      filterable: "",
                      "default-first-option": "",
                    },
                    model: {
                      value: _vm.queryForm.ware,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryForm, "ware", $$v)
                      },
                      expression: "queryForm.ware",
                    },
                  },
                  _vm._l(_vm.wareData, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "10px" },
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.query },
              },
              [_vm._v("搜索商品")]
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "10px" },
                attrs: { size: "mini", type: "warning" },
                on: { click: _vm.onReset },
              },
              [_vm._v("重置")]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "context" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData.list,
              "header-cell-style": { color: "#2E7EDF" },
            },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "image", label: "商品图片", width: "180" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-image", {
                        staticStyle: { width: "100px", height: "100px" },
                        attrs: { src: _vm.img(scope.row.image), fit: "fit" },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "title", label: "商品名称", width: "180" },
            }),
            _c("el-table-column", {
              attrs: { prop: "brandName", label: "商品品牌" },
            }),
            _c("el-table-column", {
              attrs: { prop: "sellPrice", label: "商品单价" },
            }),
            _c("el-table-column", {
              attrs: { prop: "ranking", label: "出库排行" },
            }),
            _c("el-table-column", {
              attrs: { prop: "outNumber", label: "出库总数" },
            }),
            _c("el-table-column", {
              attrs: { prop: "price", label: "出库总额" },
            }),
            _c("el-table-column", {
              attrs: { label: "仓库数量", "min-width": "150px" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm._l(scope.row.warehouses, function (item) {
                      return _c("div", { key: item.comId }, [
                        _vm._v(
                          " " + _vm._s(item.warName + ": " + item.number) + " "
                        ),
                      ])
                    })
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "quantityStock", label: "总库存" },
            }),
            _c("el-table-column", {
              attrs: { fixed: "right", label: "操作" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.onSubmit(scope.row)
                            },
                          },
                        },
                        [_vm._v("查看详细")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm.tableData.totalNum > 1
      ? _c("div", { staticClass: "page" }, [
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage1,
                  "page-size": _vm.pageSize,
                  layout: "total,sizes,prev, pager, next",
                  "prev-text": "上一页",
                  "next-text": "下一页",
                  total: !_vm.tableData ? 0 : _vm.tableData.totalNum,
                },
                on: {
                  "size-change": _vm.selectPageSize,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _c("div", { staticStyle: { height: "50px" } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }